import React from 'react';
import RaceSeriesManager from '@/features/cms/components/RaceSeriesManager';

const CmsSeriesPage: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <RaceSeriesManager />
  </div>
);

export default CmsSeriesPage;
